var _module = require('../../module');
var _ = require('lodash');
var orderListingsBy = require('../../../../libs/listing-transforms/order-listings-by');

require('../../search-results/list-item-card');
require('../../../services/search-results-utils');
require('../../listing-card');
require('../../../services/favorites');

_module.component('favoriteListings', {
    controllerAs: 'favs',
    controller: [
        '$log',
        '$scope',
        '$timeout',
        '$stateParams',
        '$user',
        '$favorites',
        '$filter',
        'srUtils',

        function favoriteListingsCtrl($log, $scope, $timeout, $stateParams, $user, $favorites, $filter, srUtils) {
            var vm = this;


            // Services
            vm.sortListByUpdated = function () {
                if(vm.sortListBy && vm.sortListBy.selected){
                    refreshFavoritesList(vm.favorites);
                }
            };

            vm.shouldShowSortByDomOption = function (opt) {
                return ((opt.title === 'Sort by Days on Market' && (vm.ui && vm.ui.showSortByDomOption)) ||
                    opt.title !== 'Sort by Days on Market');
            };

            vm.getPaginatedFavorites = function (page) {
                vm.pageData = $favorites.getPaginated(vm.favorites, page || 1);

                if(vm.pageData && vm.pageData.data && vm.pageData.data.length) {
                    vm.paginatedFavorites = vm.pageData.data;
                }else{
                    vm.paginatedFavorites = [];
                }

                //$log.debug('Got Paginated Favorites', vm.paginatedFavorites);
            };


            // Functions
            function getDetailViewParams(fav, i) {
                var params = {
                    listingId: fav.listing.id,
                    address: $filter('slug')(fav.listing.address || '')
                };

                if(!!fav.searchFilterId && fav.searchFilterId.length > 0){
                    params.filter = fav.searchFilterId;
                }

                fav.listing.detailViewParams = params;
            }

            function getNextOpenHouse(fav, i) {
                if(fav.listing && !fav.listing.hasOwnProperty('next_open_house')) {
                    fav.listing.next_open_house = srUtils.getNextOpenHouse(fav.listing);
                }
            }

            function getDaysOnMarket(fav, i) {
                if(fav.listing && !fav.listing.hasOwnProperty('days_on_market')) {
                    fav.listing.days_on_market = srUtils.getDaysOnMarket(fav.listing);
                }
            }

            function processFavorites(favorites, operation) {
                if(angular.isArray(favorites) && favorites.length > 0){
                    angular.forEach(favorites, operation, favorites);
                }
                return favorites || [];
            }

            function validateDaysOnMarketValues(favs) {
                if(favs && angular.isArray(favs) && favs.length){
                    var arr = favs.filter(function (fav, i) {
                        return fav.listing && String(fav.listing.days_on_market) !== 'null';
                    });

                    if(!arr.length) {
                        vm.ui.showSortByDomOption = false;
                        if(vm.sortListBy &&
                            vm.sortListBy.selected &&
                            vm.sortListBy.selected.title == 'Sort by Days on Market'){
                            //reset selected option in the sort by dropdown
                            initListConfig();
                        }
                    }else{
                        vm.ui.showSortByDomOption = true;
                    }
                }
            }

            function sortFavorites(results, predicate) {
                var r = results;
                if(angular.isArray(results) && results.length > 0){
                    r = $filter('orderBy')(results, predicate);
                }
                return r || [];
            }

            function refreshFavoritesList(favs) {
                var favoritesArr = JSON.parse(JSON.stringify(favs));
                favoritesArr = processFavorites(favoritesArr, getDetailViewParams);
                favoritesArr = processFavorites(favoritesArr, getNextOpenHouse);
                favoritesArr = processFavorites(favoritesArr, getDaysOnMarket);
                validateDaysOnMarketValues(favoritesArr);
                var listings = favoritesArr.map(function (fav) {
                    var listing = fav.listing;
                    if(!listing.match_score) listing.match_score = 0;
                    return listing;
                });
                listings = orderListingsBy(listings, vm.sortListBy.selected.value);
                vm.favorites = listings.map(function (listing) {
                    return _.find(favoritesArr, { listing_id: listing.id });
                });
                vm.getPaginatedFavorites(1);
            }

            function initListConfig() {
                vm.sortListBy = srUtils.getListSortObj('listing.');
            }

            function init() {
                initListConfig();
                vm.usr = $user;
                vm.ui = {
                    showSortByDomOption: false
                };

                if($user && String($user.loadingFavorites) === 'false') {
                    //$log.debug('Init Favorites Refresh');
                    refreshFavoritesList($user.favorites);
                }
            }

            init();


            /// $watch Functions
            $scope.$watch(function (scope) { return vm.usr.loadingFavorites; }, function (newVal, oldVal) {
                if(String(newVal) === 'false') {
                    //$log.debug('Favorites Loaded Refresh');
                    refreshFavoritesList($user.favorites);
                }
            });

        }
    ],
    template: require('./index.html')
});
